/* eslint-disable react/no-array-index-key */
import React, {
  useCallback,
  useEffect, useMemo, useRef, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonBackSpinner } from 'src/components/ButtonBackSpinner';
import { WindRose } from 'src/components/WindRose';
import { AppPopover } from 'src/components/AppPopover';
import {
  useAppVisibilityBtn,
  useDraggableMobileMenu,
  useAppVisibilitySpinnerBtn,
} from 'src/hooks/app';
import { ShowInfrastructure } from 'src/components/ViewSpinner/components/Infrastructure';
import { makeWindRoseData } from 'src/components/WindRose/state';
import { ListOfBacklightSvg } from 'src/typings/spinner';
import { appIcon } from 'src/assets';
import Box from '@mui/material/Box';
import { Actions } from 'src/store/spinner/actions';
import { spinnerMode } from 'src/store/spinner/reducer';
import { ListOfKeysFilterAllData, PlacementShowModule } from 'src/typings/filter';
import {
  useBuildType,
  useGetCounters,
  useGetFilteredData,
  useGetFilterParams,
  useIsMobile,
  useTranslations,
} from 'src/hooks';
import {
  useDetectAdditionalParams,
  useFloorSpinnerInteraction,
  useHouseActions,
  usePolygonConfig,
  usePopoverState,
} from 'src/components/ViewSpinner/components/RenderSvg/hooks';
import {
  getSpinnerDetailInfo,
  getSpinnerHoverText,
} from 'src/store/requests/spinner-views/selector';
import { requestSelectors } from 'src/store/requests/selectors';
import {
  useFilledPolygons,
  useGetFilteredIds,
} from 'src/components/ApartmentPageV2/ViewSpinner/components/RenderSvg/hooks';
import { PolygonTriggerEvent } from 'src/typings/app';
import { usePopup } from 'src/components/ViewSpinner/context';
import { isTouch, locals } from 'src/constants';
import { getHighlightPolygons } from 'src/store/spinner/selectors';
import { pathList } from 'src/route-list';
import { useHistory } from 'react-router';
import { getComplexId, getCrmData } from 'src/store/app/selectors';
import { IMouseEvent } from 'src/components/ViewSpinner/components/RenderSvg/types';
import { InfrastructureType, RenderHoverText } from 'src/components/ViewSpinner/components/RenderSvg/components';
import { randomHash } from 'src/helpers';
import { useSelectedDeal } from 'src/hooks/useSelectedDeal';
import { PolygonsSwitch } from 'src/components/ViewSpinner/components/PolygonsSwitch';
import { usePolygonsSwitch } from 'src/components/ViewSpinner/components/PolygonsSwitch/hooks/usePolygonsSwitch';
import {
  ArrowBack, ArrowForward, ZoomIn, ZoomOut,
} from '@mui/icons-material';
import { GlobalDataLoader } from 'src/components/GlobalDataLoader';
import { useStyles } from './styles';
import { IViewSpinner } from './types';
import {
  useInitSpinner,
  useGetSpinnerSvg,
} from './hooks';

export const ViewSpinnerInner: React.FC<IViewSpinner> = React.memo(({
  isFloors,
  setFullSizeFloor,
}) => {
  const styles = useStyles({});
  const dispatch = useDispatch();
  const { isOpenDraggableMenu } = useDraggableMobileMenu();
  const {
    currentSpinner, currentSpinnerMode, spinnerSvgCurrentDataAlt,
  } = useGetSpinnerSvg();
  const { showPolygonsRef, showPolygons } = usePolygonsSwitch();
  const { filteredIds } = useGetFilteredIds();
  const { mainSpinnerBtnViews } = useAppVisibilitySpinnerBtn();
  const [initWindRoseData, setInitWindRoseData] = useState<Function | null>(null);
  const spinnerRef = useRef<HTMLDivElement | null>(null);
  const { state } = usePopup();
  const {
    setOpenPopover,
    setTargetIsEnter,
  } = usePopoverState();
  const { infrastructure_button } = useAppVisibilityBtn();
  const { isCrossTable } = useBuildType();
  const { globalPolygonConfig } = usePolygonConfig();
  const triggerEvent: PolygonTriggerEvent = useMemo(() => globalPolygonConfig?.trigger_event
    || PolygonTriggerEvent.hover, [globalPolygonConfig]);
  const detailInfo = useSelector(getSpinnerDetailInfo);
  const hoverData = useSelector(getSpinnerHoverText);
  const { resultFiltering } = useGetFilteredData();
  const { selectedParams } = useGetFilterParams();
  const { getTranslations } = useTranslations();
  const getPopupConfig = useSelector(requestSelectors.app.getPopupConfig);
  const { handleIsSelectedFillColor } = useFilledPolygons();
  const highlightPolygonsArray = useSelector(getHighlightPolygons);
  const { handleHouseSelected } = useHouseActions();
  const { isMobileScreen } = useIsMobile();
  const { counters } = useGetCounters();
  const history = useHistory();
  const crmData = useSelector(getCrmData);
  const { isSelectedDeal, isAnyDealSelected } = useSelectedDeal();
  const complexIdState = useSelector(getComplexId);
  const [infrastructureId, setInfrastructureId] = useState<string | undefined>(undefined);
  const [isInfrastructureOpen, setIsInfrastructureOpen] = useState<boolean>(false);
  const hoverConfigRef = useRef<{ [key: string]: {active: boolean, nameId: string, hoverId: string }} | {}>({});
  const [activeEntityNameId, setActiveEntityNameId] = useState<string>('');
  const [elementsToMove, setElementsToMove] = useState<HTMLElement[] | []>([]);
  const {
    trackMouse, isHoverTextPolygon, setTrackMouse, setIsHoverPolygon,
    handleInfrastructureToggle,
  } = useDetectAdditionalParams(false);
  const {
    handleActionForFloor,
  } = useFloorSpinnerInteraction();
  const highlightPolygonsArrayRef = useRef(highlightPolygonsArray);
  highlightPolygonsArrayRef.current = highlightPolygonsArray;
  const detailInfoRef = useRef(detailInfo);
  detailInfoRef.current = detailInfo;
  const crmDataRef = useRef(crmData);
  crmDataRef.current = crmData;
  const isSelectedDealRef = useRef(isSelectedDeal);
  isSelectedDealRef.current = isSelectedDeal;
  const isAnyDealSelectedRef = useRef(isAnyDealSelected);
  isAnyDealSelectedRef.current = isAnyDealSelected;
  const countersRef = useRef(counters);
  countersRef.current = counters;
  const handleIsSelectedFillColorRef = useRef(handleIsSelectedFillColor);
  handleIsSelectedFillColorRef.current = handleIsSelectedFillColor;
  const filteredIdsRef = useRef(filteredIds);
  filteredIdsRef.current = filteredIds;
  const resultFilteringRef = useRef(resultFiltering);
  resultFilteringRef.current = resultFiltering;
  const crmSelectedDealFillOpacity = '.2';
  const showCount = (counterId: string, placeCounter: string) => {
    if (placeCounter === 'house_id') {
      return countersRef.current.house[counterId]?.count || 0;
    }
    if (placeCounter === 'section_id') {
      return countersRef.current.section[counterId]?.count || 0;
    }
    return 0;
  };

  const {
    listOfStops,
    spinner,
  } = useInitSpinner(
    isFloors,
    setFullSizeFloor,
    initWindRoseData,
    spinnerRef,
    appendChildHandler,
  );
  const [isFirstFrameLoaded, setIsFirstFrameLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (!spinner) {
      return undefined;
    }
    setIsFirstFrameLoaded(false);
    const handleFrameLoaded = () => setIsFirstFrameLoaded(true);
    spinner.addEventListener('first-frame-load', handleFrameLoaded);
    return () => {
      spinner.removeEventListener?.('first-frame-load', handleFrameLoaded);
    };
  }, [spinner]);

  const polygonHighlightColor = useMemo(() => {
    if (globalPolygonConfig) {
      return {
        color: selectedParams.length ? globalPolygonConfig.hover_body_color : globalPolygonConfig.static_body_color,
        opacity: selectedParams.length ? globalPolygonConfig.hover_body_opacity : globalPolygonConfig.static_body_opacity,
      };
    }
    return {};
  }, [selectedParams, globalPolygonConfig]);

  useEffect(() => {
    setInitWindRoseData(makeWindRoseData);
    return () => {
      setInitWindRoseData(null);
    };
  }, []);

  useEffect(() => {
    const tempElementsToMove: HTMLElement[] = [];
    spinner?.children.forEach((item: any) => {
      const entityViewName = item.userData['entity-view-name'];
      const entityViewNameId = item.userData['entity-view-name-id'];
      const isDeal = isSelectedDeal(detailInfo?.placement[entityViewNameId]);
      if (isDeal) {
        if (isDeal && !highlightPolygonsArray.length) {
          dispatch(Actions.setHighlightPolygons([entityViewNameId]));
        }
        const bestStop = detailInfo?.placement[entityViewNameId]?.[ListOfKeysFilterAllData.placementBestSpinnerStops]?.find(
          (stop) => stop['entity-view-name'] === currentSpinner?.name,
        );
        if (bestStop) {
          spinner.controls.setRotateTo([bestStop.stopNumber, 0], true);
        }
      }
      if (entityViewNameId && entityViewName) {
        if (handleIsSelectedFillColor(entityViewName, entityViewNameId)) {
          const attributeStyle = isCrossTable
            ? crossHighlighted(entityViewName, entityViewNameId, isDeal)
            : moduleHighlighted(entityViewName, entityViewNameId, isDeal);
          setAttributes(item.domElement, attributeStyle);
        } else {
          const attributeStyle = isCrossTable
            ? crossNotHighlighted(entityViewName, entityViewNameId, isDeal)
            : {
              stroke: 'transparent',
              'stroke-opacity': '0',
              fill: 'transparent',
              'fill-opacity': '0',
            };
          setAttributes(item.domElement, attributeStyle);
        }
      }
      if (item.updateCounter) item.updateCounter();

      item.domElement.classList.remove('highlightPolygon');
      if (highlightPolygonsArray.includes(entityViewNameId)) {
        const highlightPolygonStyle = {
          stroke: globalPolygonConfig?.static_border_color,
          'stroke-opacity': '1',
          // The deal unit keeps its own STATUS color: polygonHighlightColor is
          // the global static color and used to overpaint the unit dark until
          // a hover repaint restored the proper one.
          fill: isDeal ? getStaticBodyColor(entityViewNameId) : polygonHighlightColor.color,
          'fill-opacity': isDeal ? globalPolygonConfig?.static_body_opacity : polygonHighlightColor.opacity,
        };
        setAttributes(item.domElement, highlightPolygonStyle);
        item.domElement.classList.add('highlightPolygon');
        if (item.domElement.style.display !== 'none') {
          tempElementsToMove.push(item.domElement);
        }
      }
      setElementsToMove(tempElementsToMove);
    });
  }, [spinner?.children, selectedParams, filteredIds, highlightPolygonsArray, crmData, detailInfo, isAnyDealSelected, isSelectedDeal, showPolygons, isFloors]);

  useEffect(() => {
    if (elementsToMove.length) {
      elementsToMove.forEach((item) => {
        item.parentElement?.appendChild(item);
      });
    }
  }, [elementsToMove]);

  const handleSetPlacementId = useCallback((event: any, name: string, svg) => {
    if (name === ListOfBacklightSvg.placementId) {
      setTargetIsEnter(true);
      setOpenPopover(true);
      if (state.debounceOpen) {
        state.debounceOpen({
          svg,
          target: event.currentTarget,
        });
      }
    }
  }, [state, setOpenPopover, setTargetIsEnter]);

  const handleSvgClick = useCallback((event: any, redirect: string, name: string, nameId: string, viewType: string, viewId: string, svg: { tag: string, attr: any }): boolean => {
    if (redirect) {
      window.open(redirect, '_blank');
      return false;
    }
    if (isFloors) {
      handleActionForFloor(nameId);
      if (isMobileScreen && triggerEvent === PolygonTriggerEvent.hover) {
        handleSetPlacementId(event, name, svg);
      }
      if (!isMobileScreen && triggerEvent === PolygonTriggerEvent.click) {
        handleSetPlacementId(event, name, svg);
      }
      return false;
    }

    handleInfrastructureToggle();
    if (!name) return false;

    if (triggerEvent === PolygonTriggerEvent.click || isTouch) {
      if (name === ListOfBacklightSvg.houseId) {
        handleHouseSelected(name, nameId, viewType, viewId);
      } else {
        handleSetPlacementId(event, name, svg);
      }
    }
    if (triggerEvent === PolygonTriggerEvent.hover) {
      if (name === ListOfBacklightSvg.houseId) {
        handleHouseSelected(name, nameId, viewType, viewId);
      }
    }
    return true;
  }, [isFloors, isTouch, isMobileScreen, handleInfrastructureToggle, handleSetPlacementId, handleHouseSelected]);

  const handleSvgClickRef = useRef<Function>(handleSvgClick);
  handleSvgClickRef.current = handleSvgClick;

  const getStaticBodyColor = useCallback((nameId: string) => {
    return ((getPopupConfig?.enable_polygon_status_colors || isCrossTable)
      && detailInfoRef.current?.placement?.[nameId]) ? detailInfoRef.current?.placement[nameId][isCrossTable ? (
        ListOfKeysFilterAllData.placementStatusCrossTableColor
      ) : ListOfKeysFilterAllData.placementStatusColor] : `${globalPolygonConfig?.static_body_color}`;
  }, [getPopupConfig, detailInfo, isCrossTable]);

  const getHoverBodyColor = useCallback((nameId: string) => {
    return ((getPopupConfig?.enable_polygon_status_colors || isCrossTable)
      && detailInfoRef.current
      && detailInfoRef.current?.placement
      && detailInfoRef.current?.placement[nameId]
    ) ? `${
        detailInfoRef.current.placement[nameId][isCrossTable ? (
          ListOfKeysFilterAllData.placementStatusCrossTableColor || ListOfKeysFilterAllData.placementStatusColor
        ) : ListOfKeysFilterAllData.placementStatusColor]
      }` : `${globalPolygonConfig?.hover_body_color}`;
  }, [getPopupConfig, globalPolygonConfig, detailInfo, isCrossTable]);

  const isFilterActive = (name: string): boolean => {
    // @ts-ignore
    return Array.isArray(filteredIdsRef.current) ? !!filteredIdsRef.current.length : !!filteredIdsRef.current[name]?.length;
  };

  const setAttributes = (el: Element, attrs: object) => {
    Object.keys(attrs).forEach((key: string) => {
      // @ts-ignore
      el.setAttribute(key, attrs[key]);
    });
  };

  function appendChildHandler({ child }: {target: any, child: any}) {
    const { domElement, type } = child;
    domElement.id = randomHash();

    const {
      'hover-text': hoverText,
      infrastructure,
      'infrastructure-view-type': infrastructureViewType,
      'entity-view-id': entityViewId,
      'entity-view': entityView,
      'entity-view-name': entityViewName,
      'entity-view-type': entityViewType,
      'entity-view-name-id': entityViewNameId,
      'entity-view-stop': entityViewStop,
      'data-is-terrace': dataIsTerrace,
      'counter-id': counterId,
      'place-counter': placeCounter,
      redirect,
    } = child.userData;

    const clickHandler = (event: Event) => {
      const svg = { tag: 'polygon', attr: child.userData };
      const isRedirect = handleSvgClickRef.current(event, redirect, entityViewName, entityViewNameId, entityViewType, entityViewId, svg);
      if (triggerEvent === PolygonTriggerEvent.click) {
        handleSetPlacementId(event, entityViewName, svg);
        return;
      }
      if (isRedirect && entityViewName === ListOfBacklightSvg.placementId && !isMobileScreen) {
        if (!isCrossTable && detailInfoRef.current?.placement[entityViewNameId][ListOfKeysFilterAllData.placementStatusShowInModule] === PlacementShowModule.hide) {
          return;
        }
        history.push(`${isCrossTable ? `/${complexIdState}` : ''}${pathList.own}/${entityViewNameId}`);
      }
    };

    if (type === 'point') {
      const image = document.createElement('img');
      image.ondragstart = (ev) => ev.preventDefault();
      domElement.append(image);
      domElement.addEventListener('click', clickHandler);
      if (entityViewName) {
        domElement.addEventListener('mouseenter', () => { domElement.children[0].style.cursor = 'pointer'; });
        domElement.addEventListener('mouseleave', () => { domElement.children[0].style.cursor = 'default'; });
      }

      const { src: imageSrc, size: [imageWidth, imageHeight] = [] } = child.userData.image || {};

      if (counterId && placeCounter) {
        const countSize = { width: 200, height: 35 };
        const showCountValue = showCount(counterId, placeCounter);
        if (showCountValue) {
          const element = document.createElement('div');
          element.classList.add('counter');
          element.style.width = `${countSize.width}px`;
          element.style.height = `${countSize.height}px`;
          element.style.fill = 'white';
          element.style.top = '-66px';
          element.style.left = '-100px';
          const elementInner = document.createElement('div');
          elementInner.classList.add('counter-inner');
          // eslint-disable-next-line no-param-reassign
          child.updateCounter = () => {
            element.style.display = !showCountValue ? 'none' : '';
            elementInner.innerHTML = `${showCountValue} ${getTranslations(locals.appTranslations.appUnits)}`;
          };
          child.updateCounter();
          element.appendChild(elementInner);
          domElement.parentElement.appendChild(element);
        }
      }

      if (imageSrc) {
        image.src = imageSrc;
        image.style.width = imageWidth ? `${imageWidth}px` : '';
        image.style.height = imageHeight ? `${imageHeight}px` : '';
        domElement.classList.add('spinner-image');
      }
    }
    if (type === 'area') {
      if (entityViewName && entityViewNameId) {
        setAttributes(domElement, { 'entity-view-name': entityViewName, 'entity-view-name-id': entityViewNameId });
      }
      domElement.addEventListener('click', clickHandler);

      domElement.addEventListener('mouseenter', (event: Event) => {
        if (!entityViewNameId && !entityViewName) {
          setAttributes(domElement, { cursor: 'default' });
          return;
        }
        setAttributes(domElement, { cursor: 'pointer' });
        const mouseOverStyle = {
          stroke: globalPolygonConfig?.hover_border_color,
          'stroke-opacity': '1',
          'stroke-width': globalPolygonConfig?.global_border_width,
          fill: getHoverBodyColor(entityViewNameId),
          'fill-opacity': globalPolygonConfig?.hover_body_opacity,
        };

        const listOfPolygons: any[] = domElement.parentElement.querySelectorAll(`[entity-view-name="${entityViewName}"][entity-view-name-id="${entityViewNameId}"]`);
        if (listOfPolygons) {
          listOfPolygons.forEach((itemPolygon: any) => {
            if (itemPolygon && domElement.id !== itemPolygon.id) {
              setAttributes(itemPolygon, mouseOverStyle);
            }
          });
        }

        setAttributes(domElement, mouseOverStyle);
        if (triggerEvent === PolygonTriggerEvent.hover) {
          handleSetPlacementId(event, entityViewName, { tag: 'polygon', attr: child.userData });
        }
      });

      const crossMouseleave = (isDeal: boolean) => {
        // Restore EXACTLY what the initial paint pass applies — a separate
        // hand-rolled style here kept drifting from the paint rules (e.g. CRM
        // deal mode turned hovered filter matches transparent on leave).
        return handleIsSelectedFillColorRef.current(entityViewName, entityViewNameId)
          ? crossHighlightedRef.current(entityViewName, entityViewNameId, isDeal)
          : crossNotHighlightedRef.current(entityViewName, entityViewNameId, isDeal);
      };

      const moduleMouseleave = (isDeal: boolean) => {
        if (highlightPolygonsArrayRef.current.includes(entityViewNameId)) {
          return {};
        }
        return {
          stroke: handleIsSelectedFillColorRef.current(entityViewName, entityViewNameId)
            ? globalPolygonConfig?.static_border_color
            : ((isCrossTable && !isFilterActive(entityViewName)) ? globalPolygonConfig?.static_border_color : 'transparent'),
          'stroke-opacity': (crmDataRef.current && isAnyDealSelectedRef.current && !isDeal && !isFilterActive(entityViewName)) ? '0' : '1',
          fill: handleIsSelectedFillColorRef.current(entityViewName, entityViewNameId)
            ? getStaticBodyColor(entityViewNameId)
            : ((isCrossTable && !isFilterActive(entityViewName)) ? getStaticBodyColor(entityViewNameId) : 'transparent'),
          'fill-opacity': handleIsSelectedFillColorRef.current(entityViewName, entityViewNameId)
            ? globalPolygonConfig?.static_body_opacity
            : isCrossTable ? globalPolygonConfig?.static_body_opacity : '0',
        };
      };

      domElement.addEventListener('mouseleave', () => {
        if (!entityViewNameId && !entityViewName) return;
        const isDeal = isSelectedDealRef.current(detailInfoRef.current?.placement[entityViewNameId]);
        const mouseLeaveStyle = isCrossTable ? crossMouseleave(isDeal) : moduleMouseleave(isDeal);
        const listOfPolygons: any[] = domElement.parentElement.querySelectorAll(`[entity-view-name="${entityViewName}"][entity-view-name-id="${entityViewNameId}"]`);
        if (listOfPolygons) {
          listOfPolygons.forEach((itemPolygon: any) => {
            if (itemPolygon && domElement.id !== itemPolygon.id) {
              setAttributes(itemPolygon, mouseLeaveStyle);
            }
          });
        }

        setAttributes(domElement, mouseLeaveStyle);

        setTargetIsEnter(false);
        if (state.debounceClose) {
          state.debounceClose();
        }
      });
    }

    if (infrastructure && infrastructureViewType) {
      if (!isMobileScreen) {
        domElement.addEventListener('click', () => {
          setInfrastructureId(infrastructure);
          setIsInfrastructureOpen(true);
        });
        domElement.addEventListener('mousemove', (event: IMouseEvent) => {
          setTrackMouse({ x: event.clientX, y: event.clientY });
        });

        domElement.addEventListener('mouseenter', () => {
          setActiveEntityNameId(infrastructure);
          setIsHoverPolygon(true);
        });
        domElement.addEventListener('mouseleave', () => {
          setActiveEntityNameId(infrastructure);
          setIsHoverPolygon(false);
        });
      } else {
        domElement.addEventListener('touchstart', () => {
          setInfrastructureId(infrastructure);
          setIsInfrastructureOpen(true);
        });
      }

      hoverConfigRef.current = { ...hoverConfigRef.current, [infrastructure]: { active: true, nameId: infrastructure, hoverId: infrastructure } };
    }

    if (hoverText) {
      domElement.addEventListener('mousemove', (event: IMouseEvent) => {
        setTrackMouse({ x: event.clientX, y: event.clientY });
      });
      domElement.addEventListener('mouseenter', () => {
        setActiveEntityNameId(hoverText);
        setIsHoverPolygon(true);
      });
      domElement.addEventListener('mouseleave', () => {
        setActiveEntityNameId(hoverText);
        setIsHoverPolygon(false);
      });
      hoverConfigRef.current = { ...hoverConfigRef.current, [hoverText]: { active: true, nameId: hoverText, hoverId: hoverText } };
    }

    child.emit('update-user-data');
  }

  const crossHighlighted = useCallback((entityViewName: string, entityViewNameId: string, isDeal: boolean) => {
    const isActive = isFilterActive(entityViewName) || isCrossTable;
    const filterApplied = isFilterActive(entityViewName);
    if (crmData && isAnyDealSelected) {
      // CRM deal mode. Without a filter this branch also receives EVERY unit
      // when the project pre-highlights polygons — but only the current-deal
      // unit may stay highlighted then. With a real filter applied the units
      // here are genuine matches and stay highlighted alongside the deal unit.
      if (isDeal || filterApplied) {
        return {
          stroke: globalPolygonConfig?.static_border_color,
          'stroke-opacity': '1',
          fill: getStaticBodyColor(entityViewNameId),
          'fill-opacity': globalPolygonConfig?.static_body_opacity,
        };
      }
      return {
        stroke: 'transparent',
        'stroke-opacity': '0',
        fill: 'unset',
        'fill-opacity': globalPolygonConfig?.hover_body_opacity,
      };
    }
    return {
      stroke: isActive ? globalPolygonConfig?.static_border_color : 'transparent',
      'stroke-opacity': crmData && !isDeal && !isActive ? '0' : '1',
      fill: isActive ? getStaticBodyColor(entityViewNameId) : 'transparent',
      'fill-opacity': isActive
        ? globalPolygonConfig?.static_body_opacity
        : 'transparent',
    };
  }, [detailInfo, globalPolygonConfig, crmData, isAnyDealSelected, isSelectedDeal, resultFiltering, filteredIds, isCrossTable]);

  const moduleHighlighted = useCallback((entityViewName: string, entityViewNameId: string, isDeal: boolean) => {
    const isActive = isFilterActive(entityViewName);
    return {
      stroke: handleIsSelectedFillColorRef.current(entityViewName, entityViewNameId)
        ? globalPolygonConfig?.static_border_color
        : (((!isCrossTable && !isActive && globalPolygonConfig?.is_pre_highlight_polygons_in_module) || isCrossTable) ? globalPolygonConfig?.static_border_color : 'transparent'),
      'stroke-opacity': crmData && !isDeal && !isActive ? '0' : '1',
      fill: handleIsSelectedFillColorRef.current(entityViewName, entityViewNameId)
        ? getStaticBodyColor(entityViewNameId)
        : (((!isCrossTable && !isActive && globalPolygonConfig?.is_pre_highlight_polygons_in_module) || isCrossTable) ? getStaticBodyColor(entityViewNameId) : 'transparent'),
      'fill-opacity': handleIsSelectedFillColorRef.current(entityViewName, entityViewNameId)
        ? globalPolygonConfig?.static_body_opacity
        : (((!isCrossTable && !isActive && globalPolygonConfig?.is_pre_highlight_polygons_in_module) || isCrossTable) ? crmSelectedDealFillOpacity : globalPolygonConfig?.hover_body_opacity),
    };
  }, [detailInfo, globalPolygonConfig, crmData, isAnyDealSelected, isSelectedDeal, resultFiltering, filteredIds, showPolygonsRef, isFloors]);

  const crossNotHighlighted = useCallback((entityViewName: string, entityViewNameId: string, isDeal: boolean) => {
    const isActive = isFilterActive(entityViewName) || !resultFiltering.length;
    if (crmData && isAnyDealSelected) {
      // CRM deal mode: ONLY the current-deal unit stays highlighted here —
      // even when it does not pass the applied filter. Filter matches are
      // painted by crossHighlighted, everything else is not highlighted.
      if (isDeal) {
        return {
          stroke: globalPolygonConfig?.static_border_color,
          'stroke-opacity': '1',
          fill: getStaticBodyColor(entityViewNameId),
          'fill-opacity': globalPolygonConfig?.static_body_opacity,
        };
      }
      return {
        stroke: 'transparent',
        'stroke-opacity': '0',
        fill: 'unset',
        'fill-opacity': globalPolygonConfig?.hover_body_opacity,
      };
    }
    return {
      stroke: !isActive ? globalPolygonConfig?.static_border_color : 'transparent',
      'stroke-opacity': !isActive ? '1' : '0',
      fill: !isActive ? getStaticBodyColor(entityViewNameId) : 'unset',
      'fill-opacity': !isActive ? globalPolygonConfig?.static_body_opacity : globalPolygonConfig?.hover_body_opacity,
    };
  }, [detailInfo, globalPolygonConfig, crmData, isAnyDealSelected, isSelectedDeal, resultFiltering, filteredIds, highlightPolygonsArray]);

  // Mouseleave listeners live as long as the polygon element — they must
  // restore styles through the LATEST paint logic, not the render-time one.
  const crossHighlightedRef = useRef(crossHighlighted);
  crossHighlightedRef.current = crossHighlighted;
  const crossNotHighlightedRef = useRef(crossNotHighlighted);
  crossNotHighlightedRef.current = crossNotHighlighted;

  const isSpinnerModeChangeBtnVisible = useMemo(() => {
    if (spinnerSvgCurrentDataAlt && currentSpinner) {
      return !!Object.keys(spinnerSvgCurrentDataAlt[currentSpinner.name]).length;
    }
    return false;
  }, [spinnerSvgCurrentDataAlt, currentSpinner]);

  const changeSpinnerMode = (mode: spinnerMode) => {
    dispatch(Actions.setSpinnerMode(mode));
  };

  return (
    <>
      <div
        id="spinner_place"
        className={
          `${isFloors ? styles.floorsView : ''} ${
            isOpenDraggableMenu ? '' : styles.blurStyle}`
        }
      >
        {!isFirstFrameLoaded && <GlobalDataLoader />}
        {!isFloors && <ButtonBackSpinner className={styles.backButton} />}
        <div>
          <div id="spinner_canvas" ref={spinnerRef} className={`${styles.svgPlace} ${styles.styleCanvas}`} />
        </div>
        {listOfStops && listOfStops.length > 1 && (
          <div id="spinner_control" className={`${mainSpinnerBtnViews}`}>
            {
              listOfStops.length > 1 && (
                <>
                  <div id="turn_left"><ArrowBack className="arrow_back" /></div>
                  {isSpinnerModeChangeBtnVisible && (
                    <>
                      {currentSpinnerMode === spinnerMode.night && (
                        <Box id="day_night" className="day" onClick={() => changeSpinnerMode(spinnerMode.day)}><img src={appIcon.day.default} alt="night" /></Box>
                      )}
                      {currentSpinnerMode === spinnerMode.day && (
                        <Box id="day_night" className="night" onClick={() => changeSpinnerMode(spinnerMode.night)}><img src={appIcon.night.default} alt="night" /></Box>
                      )}
                    </>
                  )}
                  <div id="turn_right"><ArrowForward className="arrow_forward" /></div>
                </>
              )
            }
            <div id="spinner_zoom"><ZoomIn /></div>
            <div id="spinner_unzoom"><ZoomOut /></div>
          </div>
        )}

        {initWindRoseData && <WindRose initWindRoseData={initWindRoseData} />}
        <div id="porgress_bar" />
        <div className={styles.switchesWrapper}>
          {!isCrossTable && !isFloors && <PolygonsSwitch />}
          {infrastructure_button && !isFloors ? <ShowInfrastructure /> : null}
        </div>
        <AppPopover />
        {infrastructureId && (
          <InfrastructureType
            isOpen={isInfrastructureOpen}
            infrastructureId={infrastructureId}
            handleToggle={() => setIsInfrastructureOpen(false)}
          />
        )}
        {hoverData && Object.keys(hoverConfigRef.current || {}).map((key) => {
          // @ts-ignore
          const dataObject = hoverConfigRef.current[key];
          return (isHoverTextPolygon && activeEntityNameId === key && (
            <Box key={key}>
              <RenderHoverText
                isEnableHoverPopup={dataObject.active}
                nameId={dataObject.nameId}
                hoverId={dataObject.hoverId}
                trackMouse={trackMouse}
                handleHover={setIsHoverPolygon}
              />
            </Box>
          ));
        })}
      </div>
    </>
  );
});

ViewSpinnerInner.displayName = 'ViewSpinnerInner';
